import { render, staticRenderFns } from "./InputGeneric.vue?vue&type=template&id=195e85d3&"
import script from "./InputGeneric.vue?vue&type=script&lang=js&"
export * from "./InputGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('195e85d3')) {
      api.createRecord('195e85d3', component.options)
    } else {
      api.reload('195e85d3', component.options)
    }
    module.hot.accept("./InputGeneric.vue?vue&type=template&id=195e85d3&", function () {
      api.rerender('195e85d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/InputGeneric.vue"
export default component.exports